import {dimensions, loadValues1, loadValues} from '../../aggregation/countAggregation'
import {parallelCoordinatesPlotBrush} from '../../Brushing/ParallelCoordinatesBrush'
import {d3multibrush, d3v3event, d3v3, d3origin, d3v4eventthis} from  '../../../../libjs/d3multibrush/multibrush.js'
import {
    histogramPredictionDataset,
    HistogramPrediction,
    brushingDataset,
    BrushingDataSet,
    BrushingPointsBarChart,
    PredictionPointsParallelCoordinates,
    ParallelCoordinatesPrediction,
    ParallelCoordinateBrushObject
} from "../../../Globals/Globals";
import * as buckets from 'buckets-js'
import {
  PREDICTION_HISTOGRAM_DRAW_BAR,
  PREDICTION_HISTOGRAM_DRAW_PAINT,
  HISTOGRAM_CHART,
  SCATTERPLOT_CHART,
  PREDICTION,
  ACTUAL,
  SEEDATA,
  LINE_CHART,
  COMBINED,
  COMBINEDSTACKEDBARCHART,
  COMBINEDGROUPBARCHART,
  PREDICTION_HISTOGRAM_CANVAS_CLEAR,
  PREDICTION_HISTOGRAM_CANVAS_PENCIL,
  BAR_CHART,
  PARALLEL_COORDINATES_CHART
} from "../../Canvas/Constants";

import {PREDICTION_COLOR, REALDATA_COLOR, BRUSHING_COLOR, NO_PREDICTION_COLOR, PARALLELCOORDINATES_PREDCITION_SEEDATA_COLOR ,PARALLELCOORDINATES_PREDCITION_INCORRECT_SEEDATA_COLOR} from "../../../Globals/ColorConstants"

import {LogEvents} from '../../../Globals/Globals'
import {LOG_EVENT_TYPE_CHART_CREATED, LOG_EVENT_TYPE_CHART_DRAG_ENDED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DESTROYED, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED
    ,LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, 
    LOG_EVENT_TYPE_CHART_BRUSHING_STARTED, LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED} from '../../../Globals/LogConstants'
    

export function drawPredictionLineActual(dataAll, row){

  var pathElements = document.getElementsByClassName('forepath')
  var key, value, keys, values, dataIdsMap ={}, nondataIdsMap={}
  console.log('drawPredictionLineActual',dataAll, row)
  for(let k=0;k< dataAll.length;k++)
  {
    key = dataAll[k][0]
    if(dataIdsMap[key] ==null)
    {
      dataIdsMap[key] = []
    }
    if(nondataIdsMap[key] ==null)
    {
      nondataIdsMap[key] = []
    }

  }
  for (let i = 0; i < pathElements.length; i++) {
     
      var ID = pathElements[i].classList[1]
      for(let k=0;k< dataAll.length;k++)
      {
        key = dataAll[k][0]
        values = dataAll[k][1]
        keys = key.split(':')
        var dataIds = []
        var nondataIds = []
     
        if(values[2].dim.type == 'string' && values[3].dim.type != 'string')
        {
              var categories = values[2].dim.scale.invert(values[0][0], values[0][1])

             if((loadValues1[ID][keys[2]]>=values[1][0] && loadValues1[ID][keys[2]] <=values[1][1]) && categories.includes(loadValues1[ID][keys[1]]))
              {
                if(dataIdsMap[key] ==null)
                {
                  dataIdsMap[key] = [ID]
                }
                else
                {
                  dataIdsMap[key].push(ID)
                  dataIds.push(ID)
                
                }
              }
              else
              {
               
                if(nondataIdsMap[key] ==null)
                {
                  nondataIdsMap[key] = [ID]
                }
                else
                {
                  nondataIdsMap[key].push(ID)
                  dataIds.push(ID)
                
                }
             
              }

        }
        else if(values[3].dim.type == 'string' && values[2].dim.type != 'string' ) 
        {
            var categories = values[3].dim.scale.invert(values[1][0], values[1][1])

           
            if(categories.includes(loadValues1[ID][keys[2]]) && 
              (loadValues1[ID][keys[1]]>=values[0][0]  && loadValues1[ID][keys[1]] <=values[0][1]))
              {
                if(dataIdsMap[key] ==null)
                {
                  dataIdsMap[key] = [ID]
                }
                else
                {
                  dataIdsMap[key].push(ID)
                  dataIds.push(ID)
                
                }
              }
              else
              {
                if(nondataIdsMap[key] ==null)
                {
                  nondataIdsMap[key] = [ID]
                }
                else
                {
                  nondataIdsMap[key].push(ID)
                  dataIds.push(ID)
                
                }
              }
        }
        else if(values[2].dim.type == 'string' && values[3].dim.type == 'string')
        {
            var categories1 = values[2].dim.scale.invert(values[0][0], values[0][1])
            var categories2 = values[3].dim.scale.invert(values[1][0], values[1][1])

           
            if(categories2.includes(loadValues1[ID][keys[2]]) && categories1.includes(loadValues1[ID][keys[1]]))
            {
              if(dataIdsMap[key] ==null)
              {
                dataIdsMap[key] = [ID]
              }
              else
              {
                dataIdsMap[key].push(ID)
                dataIds.push(ID)
              
              }
            }
            else
            {
              if(nondataIdsMap[key] ==null)
              {
                nondataIdsMap[key] = [ID]
              }
              else
              {
                nondataIdsMap[key].push(ID)
                dataIds.push(ID)
              
              }
            }

        }
        else
        {

          
          if((loadValues1[ID][keys[2]]>=values[1][0] && loadValues1[ID][keys[2]] <=values[1][1]) && 
              (loadValues1[ID][keys[1]]>=values[0][0]  && loadValues1[ID][keys[1]] <=values[0][1]))
              {
                if(dataIdsMap[key] ==null)
                {
                  dataIdsMap[key] = [ID]
                }
                else
                {
                  dataIdsMap[key].push(ID)
                  dataIds.push(ID)
                
                }
              }
              else
              {
                if(nondataIdsMap[key] ==null)
                {
                  nondataIdsMap[key] = [ID]
                }
                else
                {
                  nondataIdsMap[key].push(ID)
                  dataIds.push(ID)
                
                }
              }
        }
        

     

      }
  }

  console.log('dataIdsMap', dataIdsMap, row)
  var finaldataIds = []
  for (let [key, value] of Object.entries(dataIdsMap)) {
    finaldataIds.push(value)
  }
  var nonfinaldataIds = []

 // for (let [key, value] of Object.entries(nondataIdsMap)) {
   // nonfinaldataIds.push(value)
 // }

//  console.log('finaldataIds', finaldataIds, nonfinaldataIds)
  if(finaldataIds.length>0)
  {
    
    var finalresultdataIds = finaldataIds.shift().filter(function(v) {
      if(finaldataIds.every(function(a) {
        //   console.log('nonfinalresultdataIds',v,a, a.indexOf(v))  
               return a.indexOf(v) !== -1;
         }) == true)
         {
           return true
         }
         else
         {
          nonfinaldataIds.push(v)
         } 
    });


    console.log('finaldataIds', finalresultdataIds, nonfinaldataIds, row)
      var foregroundPrediction = document.getElementsByClassName('.forepath')
      var graph_forepaths= document.getElementsByClassName("forepath");

    
      for (let i = 0; i < graph_forepaths.length; i++) {
              var splitIds = graph_forepaths[i].getAttribute("id").split("_");
              var currentdataID = splitIds[splitIds.length - 1];
            
              if (finalresultdataIds.indexOf(currentdataID) >= 0) {
                      graph_forepaths[i].setAttribute(
                              "style",
                              "opacity: 1.0; stroke: "+REALDATA_COLOR+";stroke-width:2.5"
                      );
                    
              }

             /* if (nonfinaldataIds.indexOf(currentdataID) >= 0) {
                graph_forepaths[i].setAttribute(
                        "style",
                        "opacity: 0.2; stroke: "+"red"+";stroke-width:2.5"
                );
                }
              */
        
            
           
      }
  }
 // console.log('nonfinalresultdataIds',nonfinalresultdataIds)
     
  
  

}

export function drawPredictionActual(key, value, xscale, predictionParallelCoordinate){
  var backgroundPrediction = d3v3.select('.predictionActual')
  
  key = key.replace(/:/g, '')

  //var area_path = backgroundPrediction.selectAll(".\\3"+key)
  var random 
  var area_path
  if(predictionParallelCoordinate.predictionLines[key] != null)
  {
    random = predictionParallelCoordinate.predictionLines[key]

    var area_path = backgroundPrediction.selectAll("."+random)
  }
  
  var extent1 = value[0]
  var extent2 = value[1]
  var brushInstance1 = value[2]
  var brushInstance2 = value[3]
  console.log('brushInstance1.xscale(brushInstance1.dim.name)',brushInstance1.xscale(brushInstance1.dim.name),brushInstance1.xscale(brushInstance2.dim.name),brushInstance1.xscale, random, predictionParallelCoordinate.predictionLines, area_path)
  var xaxis1Value = xscale(brushInstance1.dim.name)
  var xaxis2Value = xscale(brushInstance2.dim.name)       
  /*var data = [

    {
      x0: xaxis1Value,
      x1: xaxis2Value,
      y0: brushInstance1.dim.scale(extent1[0]),
      y1: brushInstance2.dim.scale(extent2[0]),
    
    },
    {
      x0: xaxis1Value,
      x1: xaxis2Value,
      y0: brushInstance1.dim.scale(extent1[1]),
      y1: brushInstance2.dim.scale(extent2[1]),
    },
]*/


    var s1,s2,s3,s4
    s1 = brushInstance1.dim.scale(extent1[0])
    s2 = brushInstance1.dim.scale(extent1[1])
    s3 = brushInstance2.dim.scale(extent2[0])
    s4 = brushInstance2.dim.scale(extent2[1])

    if(brushInstance1.dim.type == 'string' && brushInstance2.dim.type != 'string')
    {
      s1 = extent1[1]
      s2 = extent1[0]
    }
    else if (brushInstance2.dim.type == 'string' && brushInstance1.dim.type != 'string' )
    {
      s3 = extent2[1]
      s4 = extent2[0]
    }

    if(brushInstance1.dim.type == 'string' && brushInstance2.dim.type == 'string')
    {
      s1 = extent1[1]
      s2 = extent1[0]
      s3 = extent2[1]
      s4 = extent2[0]

    }
    var data = [

      {
        x0: xaxis1Value,
        x1: xaxis2Value,
        y0: s1,
        y1: s3,
      
      },
      {
        x0: xaxis1Value,
        x1: xaxis2Value,
        y0: s2,
        y1: s4,
      },
  ]
 
  var areaFunc = d3v3.svg.area()
  .interpolate('step')            
  .x0(function(d){return d.x0;})
  .x1(function(d){return d.x1;})
  .y0(function(d){return d.y0;})
  .y1(function(d){return d.y1;});



  if(area_path==undefined || area_path["0"].length == 0)
  {
  
    backgroundPrediction
    .append('path')
    .attr('d', areaFunc(data))
    .attr('class', random)
    .attr('style', 'fill:'+PREDICTION_COLOR+';stroke:black;stroke-width:1;opacity:1.0'); 
  }
  else
  {
  
    var area_path = backgroundPrediction.selectAll("."+random)
    .data([data], function(d, i){ return i; });


    area_path
    .transition()
      .attr("d", areaFunc);
  }



}


export function drawPredictionPredidction(id, key, value, xscale){
  var backgroundPrediction = d3v3.select('#'+id+'prediction')
  console.log('backgroundPrediction',backgroundPrediction, key)
  key = key.replace(/:/g, '')
  var area_path = backgroundPrediction.selectAll(".\\3"+key)
  
  var extent1 = value[0]
  var extent2 = value[1]
  var brushInstance1 = value[2]
  var brushInstance2 = value[3]
  console.log('brushInstance1.xscale(brushInstance1.dim.name)',brushInstance1.xscale(brushInstance1.dim.name),brushInstance1.xscale(brushInstance2.dim.name),brushInstance1.xscale)
  var xaxis1Value = xscale(brushInstance1.dim.name)
  var xaxis2Value = xscale(brushInstance2.dim.name)   
  var data    
  /*var data = [

    {
      x0: xaxis1Value,
      x1: xaxis2Value,
      y0: brushInstance1.dim.scale(extent1[0]),
      y1: brushInstance2.dim.scale(extent2[0]),
    
    },
    {
      x0: xaxis1Value,
      x1: xaxis2Value,
      y0: brushInstance1.dim.scale(extent1[1]),
      y1: brushInstance2.dim.scale(extent2[1]),
    },
  ]
  */

  



  var areaFunc = d3v3.svg.area()
  .interpolate('step')            
  .x0(function(d){return d.x0;})
  .x1(function(d){return d.x1;})
  .y0(function(d){return d.y0;})
  .y1(function(d){return d.y1;});


  console.log('area_patharea_path',area_path, key)
  if(area_path=null || area_path["0"].length == 0)
  {
    
    backgroundPrediction
    .append('path')
    .attr('d', areaFunc(data))
    .attr('class', key+" "+key)
    .attr('style', 'fill:'+PREDICTION_COLOR+';stroke:black;stroke-width:1;opacity:0.2'); 
  }
  else
  {
   
    var area_path = backgroundPrediction.selectAll(".\\3"+key)
    .data([data], function(d, i){ return i; });


    area_path
    .transition()
      .attr("d", areaFunc);
  }



}

function drawPrediction(predictionParallelCoordinates, target, id){

 
  if(target !="")
  {
    console.log('predictionParallelCoordinates',predictionParallelCoordinates)
    for(var row=0;row<predictionParallelCoordinates.axesPrediction.length;row++)
    {
      var predictionParallelCoordinate:ParallelCoordinatesPrediction = predictionParallelCoordinates.axesPrediction[row]
  
      console.log('brushes11',predictionParallelCoordinate.brush.toArray())
      var brushes = predictionParallelCoordinate.brush.toArray()

      for(var row1=0;row1<brushes.length;row1++)
      {
        var brushInstance1 = brushes[row1]
     
        if(brushInstance1.id == target)
        {
            var data1, data2
          
            if(row1-1>=0)
            {
            
            
              var brushInstance2 = brushes[row1-1]
              console.log('targettarget brushInstance1.id',target, brushInstance1.id, row1-1, row1+1, row, brushInstance1, brushInstance2)
            
           
              var extents1brush = predictionParallelCoordinates.axesPredictionBrushInstanes[brushInstance1.dim.name].extent()
              var extents2brush= predictionParallelCoordinates.axesPredictionBrushInstanes[brushInstance2.dim.name].extent()
              console.log('targettarget',extents1brush, extents2brush, predictionParallelCoordinates.axesPredictionBrushInstanes[brushInstance1.dim.name],
              predictionParallelCoordinates.axesPredictionBrushInstanes[brushInstance2.dim.name])
              var xaxis1Value = brushInstance1.xscale(brushInstance1.dim.name)
              var xaxis2Value = brushInstance2.xscale(brushInstance2.dim.name)
              var extent1 = extents1brush[row]
              var extent2 = extents2brush[row]
              

              var s1,s2,s3,s4
              s1 = brushInstance1.dim.scale(extent1[0])
              s2 = brushInstance1.dim.scale(extent1[1])
              s3 = brushInstance2.dim.scale(extent2[0])
              s4 = brushInstance2.dim.scale(extent2[1])
           
              if(extents1brush['target']== 'string' &&  extents2brush['target'] != 'string')
              {
                s1 = extent1[1]
                s2 = extent1[0]
              }
              else if (extents2brush['target'] == 'string' && extents1brush['target'] != 'string')
              {
                s3 = extent2[1]
                s4 = extent2[0]
              }

              if(extents1brush['target']== 'string' && extents2brush['target'] == 'string')
              {
                s1 = extent1[1]
                s2 = extent1[0]
                s3 = extent2[1]
                s4 = extent2[0]

              }
              data1 = [

                {
                  x0: xaxis1Value,
                  x1: xaxis2Value,
                  y0: s1,
                  y1: s3,
                
                },
                {
                  x0: xaxis1Value,
                  x1: xaxis2Value,
                  y0: s2,
                  y1: s4,
                },
            ]
          
          
            }

            if(row1+1<=brushes.length && row1+1<brushes.length)
            {

              var brushInstance2 = brushes[row1+1]
              var extents1brush = predictionParallelCoordinates.axesPredictionBrushInstanes[brushInstance1.dim.name].extent()
              var extents2brush= predictionParallelCoordinates.axesPredictionBrushInstanes[brushInstance2.dim.name].extent()
          
              
              var xaxis1Value = brushInstance1.xscale(brushInstance1.dim.name)
              var xaxis2Value = brushInstance2.xscale(brushInstance2.dim.name)
              var extent3 = extents1brush[row]
              var extent4 = extents2brush[row]
             

              var s1,s2,s3,s4
              s1 = brushInstance2.dim.scale(extent4[0])
              s2 = brushInstance2.dim.scale(extent4[1])
              s3 = brushInstance1.dim.scale(extent3[0])
              s4 = brushInstance1.dim.scale(extent3[1])

              if(extents2brush['target'] == 'string' && extents1brush['target'] != 'string')
              {
                s1 = extent4[1]
                s2 = extent4[0]
              }
              else if (extents1brush['target'] == 'string' && extents2brush['target'] != 'string' )
              {
                s3 = extent3[1]
                s4 = extent3[0]
              }

              if(extents2brush['target'] == 'string' && extents1brush['target'] == 'string')
              {
                s1 = extent4[1]
                s2 = extent4[0]
                s3 = extent3[1]
                s4 = extent3[0]
              }

              data2 = [
                {
                  x0: xaxis2Value,
                  x1: xaxis1Value,
                  y0: s1,
                  y1: s3,
                
                },
                {
                  x0: xaxis2Value,
                  x1: xaxis1Value,
                  y0: s2,
                  y1: s4,
                },
            ]
         
            

            }
            if(data1 && data2)
            {
              var brushInstance2 = brushes[row1-1]
              var brushInstance3 = brushes[row1+1]
              var backgroundPrediction = d3v3.select('#'+id+'prediction')
              var class1 = row+brushInstance1.dim.name+brushInstance2.dim.name
              var class2 = row+brushInstance3.dim.name+brushInstance1.dim.name
              
              var random1
              if(predictionParallelCoordinate.predictionLines[class1] == null)
              {
                random1 = 'bands_'+(Math.floor(Math.random() * 1000) + 1).toString();
                predictionParallelCoordinate.predictionLines[class1] =  random1
               
                
              }
              else
              {
                random1 = predictionParallelCoordinate.predictionLines[class1]
              }
            
              var random2
              if(predictionParallelCoordinate.predictionLines[class2] == null)
              {
                random2 = 'bands_'+(Math.floor(Math.random() * 1000) + 1).toString();
                predictionParallelCoordinate.predictionLines[class2] =  random2
               
                
              }
              else
              {
                random2 = predictionParallelCoordinate.predictionLines[class2]
              }

              predictionParallelCoordinate.predictionPoints[row+":"+brushInstance2.dim.name+":"+brushInstance1.dim.name] = [extent1, extent2, brushInstance1, brushInstance2]
              predictionParallelCoordinate.predictionPoints[row+":"+brushInstance3.dim.name+":"+brushInstance1.dim.name] = [extent3, extent4, brushInstance1, brushInstance3]

              
              var dataAll = []
              for (let [key, value] of Object.entries(predictionParallelCoordinate.predictionPoints)) {

                if(key == row+brushInstance1.dim.name+brushInstance2.dim.name )
                {
                  dataAll.push(value)
                }
                if(key == row+brushInstance3.dim.name+brushInstance1.dim.name)
                {
                  dataAll.push(value)
                }
            
              }


              var area_path1 = backgroundPrediction.selectAll("."+random1)
                .data([data1], function(d, i){ return i; });

              var area_path2 = backgroundPrediction.selectAll("."+random2)
                .data([data2], function(d, i){ return i; });
                

                var areaFunc = d3v3.svg.area()
                .interpolate('step')            
                .x0(function(d){return d.x0;})
                .x1(function(d){return d.x1;})
                .y0(function(d){return d.y0;})
                .y1(function(d){return d.y1;});

                area_path1
                  .transition()
                    .attr("d", areaFunc);
                area_path2
                    .transition()
                      .attr("d", areaFunc);

            }
            else
            {
              if(data1)
              {
                var brushInstance2 = brushes[row1-1]
                var backgroundPrediction = d3v3.select('#'+id+'prediction')
                var class1 = row+brushInstance1.dim.name+brushInstance2.dim.name
                var random 
                if(predictionParallelCoordinate.predictionLines[class1] == null)
                {
                  random = 'bands_'+(Math.floor(Math.random() * 1000) + 1).toString();
                  predictionParallelCoordinate.predictionLines[class1] =  random
                 
                 
                }
                else
                {
                 
                  random = predictionParallelCoordinate.predictionLines[class1]
                 
                }
                
                
                predictionParallelCoordinate.predictionPoints[row+":"+brushInstance1.dim.name+":"+brushInstance2.dim.name] = [extent1, extent2, brushInstance1, brushInstance2]
              
                var area_path = backgroundPrediction.selectAll("."+random)
                console.log('logsssdata1',data1, backgroundPrediction, area_path)
              

                var areaFunc = d3v3.svg.area()
                .interpolate('step')            
                .x0(function(d){return d.x0;})
                .x1(function(d){return d.x1;})
                .y0(function(d){return d.y0;})
                .y1(function(d){return d.y1;});
              
              
             
                if(area_path==null || area_path["0"].length == 0)
                {
                
                  backgroundPrediction
                  .append('path')
                  .attr('d', areaFunc(data1))
                  .attr('class', random)
                  .attr('style', 'fill:'+PREDICTION_COLOR+';stroke:black;stroke-width:1;opacity:1.0'); 
                }
                else
                {
                  var area_path = backgroundPrediction.selectAll("."+random)
               
                  .data([data1], function(d, i){ return i; });
                  console.log('update area',area_path)

                  area_path
                  .transition()
                    .attr("d", areaFunc);
                }
              


              
              }

              if(data2)
              {
                var brushInstance2 = brushes[row1+1]
                var backgroundPrediction = d3v3.select('#'+id+'prediction')
                var class1 = row+brushInstance2.dim.name+brushInstance1.dim.name
                var random
                if(predictionParallelCoordinate.predictionLines[class1] == null)
                {
                  
                  random = 'bands_'+(Math.floor(Math.random() * 1000) + 1).toString();
                  predictionParallelCoordinate.predictionLines[class1] =  random
                 
                }
                else
                {
                  random = predictionParallelCoordinate.predictionLines[class1]
                }

                predictionParallelCoordinate.predictionPoints[row+":"+brushInstance2.dim.name+":"+brushInstance1.dim.name] = [extent3, extent4, brushInstance1, brushInstance2]
                var area_path = backgroundPrediction.selectAll("."+random)
                var areaFunc = d3v3.svg.area()
                .interpolate('step')            
                .x0(function(d){return d.x0;})
                .x1(function(d){return d.x1;})
                .y0(function(d){return d.y0;})
                .y1(function(d){return d.y1;});

          
                if(area_path==null || area_path["0"].length == 0)
                {
                
                  backgroundPrediction
                  .append('path')
                  .attr('d', areaFunc(data2))
                  .attr('class', random)
                  .attr('style', 'fill:'+PREDICTION_COLOR+';stroke:black;stroke-width:1;opacity:1.0'); 
                }
                else
                {
                  var area_path = backgroundPrediction.selectAll("."+random)
                  .data([data2], function(d, i){ return i; });
                  console.log('update area',area_path)
                  
                  area_path
                  .transition()
                    .attr("d", areaFunc);
                }
              

              
              }
          }
        }
      }

    

    }
  }
}
export function pre_brush_parallel_chart(predictionLastBrushAxes, predictionLastBrush, dimbrush, predictionParallelCoordinates: PredictionPointsParallelCoordinates, extents,dim, xScale, brushRectIds, id,event) { 

  

   console.log('brusing,',d3v3event.sourceEvent, d3v3event.target.extent)
   var target = d3v3.event.target.eventtarget[0][0].id
   if(target =='')
   {
     if(d3v3.event.target.redrawTarget!=undefined)
     {
      target = brushRectIds[dim.name][d3v3.event.target.redrawTarget]
     }
  
   }
    console.log('brushchart', target, d3v3.event.target, d3v3.event.target.eventtarget, d3v3.event.target.eventtargetg)
   drawPrediction(predictionParallelCoordinates, target, id)
   
   
       
 }



 export function pre_brush_end(predictionLastBrushAxes, predictionLastBrush, dimbrush, predictionParallelCoordinates: PredictionPointsParallelCoordinates, extents,dim, xScale, brushRectIds, id, zaxisList, event){

 
  var row = 0
  console.log('pre_brush_end',id)
  var rectelements = d3v3.select("#"+dim.name+"_parallelCoordinates")
                        .selectAll('rect')
  var rectelements = rectelements[0]
  brushRectIds[dim.name] = []
  for(var i=0;i<rectelements.length;i++)
  {
    if(rectelements[i].id !=null && rectelements[i].id.includes('rect'))
    {
      brushRectIds[dim.name].push(rectelements[i].id)
    }
  }
  brushRectIds[dim.name].pop()
  
  

 
 

  var targetIds = brushRectIds[dim.name]
 
  if(targetIds.length>0)
  {
    var targetId = targetIds[targetIds.length-1]
    console.log('targetIds',targetIds, brushRectIds)
    if(!predictionParallelCoordinates.axesPredictionBrushes.includes(targetId))
    {

        var axesExists = true
        predictionParallelCoordinates.axesPredictionBrushes.push(targetId)
        if(predictionParallelCoordinates.axesPredictionBrushInstanes[dim.name] == null)
        {
            predictionParallelCoordinates.axesPredictionBrushInstanes[dim.name] = d3v3.event.target
        }
        for(row=0;row<predictionParallelCoordinates.axesPrediction.length;row++)
        {
          var predictionParallelCoordinate:ParallelCoordinatesPrediction = predictionParallelCoordinates.axesPrediction[row]
          if(!predictionParallelCoordinate.axes.includes(dim.name))
          {
            axesExists = false
            break
          }

        }
        if(axesExists)
        {
            predictionParallelCoordinate = new ParallelCoordinatesPrediction()
            predictionParallelCoordinate.brush = new   buckets.LinkedList<any>()
            predictionParallelCoordinate.axes = new  Array<string>()
            predictionParallelCoordinate.predictionPoints = new Map<string,any>()
            predictionParallelCoordinate.predictionLines = new Map<string,string>()

            var parallelCoordinateBrushObject = new ParallelCoordinateBrushObject()
            parallelCoordinateBrushObject.id = targetId
            parallelCoordinateBrushObject.dim = dim
            parallelCoordinateBrushObject.xscale = xScale
          
            predictionParallelCoordinate.brush.add(parallelCoordinateBrushObject)
            predictionParallelCoordinate.axes.push(dim.name)
           
            predictionParallelCoordinates.axesPrediction.push(predictionParallelCoordinate)
        
            drawPrediction(predictionParallelCoordinates, targetId, id)
        }
        else
        {
            
            predictionParallelCoordinate = predictionParallelCoordinates.axesPrediction[row]

            var parallelCoordinateBrushObject = new ParallelCoordinateBrushObject()
            parallelCoordinateBrushObject.id = targetId
            parallelCoordinateBrushObject.dim = dim
            parallelCoordinateBrushObject.xscale = xScale
            
            predictionParallelCoordinate.brush.add(parallelCoordinateBrushObject)
            console.log('parallelCoordinateBrushObject',predictionParallelCoordinate.brush.toArray())
            predictionParallelCoordinate.axes.push(dim.name)
            drawPrediction(predictionParallelCoordinates, targetId, id)

        }
    }

  }

  var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
  if(logevents)
  {
          var eventlog = LogEvents.addEvent(id, PARALLEL_COORDINATES_CHART, PREDICTION, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, null, null,null,null,zaxisList)
          logevents._logEvents.push(eventlog)
          sessionStorage.setItem('logevents', JSON.stringify(logevents))
  }
  
    if (!d3v3event.sourceEvent) return; // Only transition after input.
    if (!d3v3event.selection) return; // Ignore empty selections.
     

  
  }


  export function pre_brushstart(predictionLastBrushAxes, predictionLastBrush, dimbrush, predictionParallelCoordinates: PredictionPointsParallelCoordinates, extents,dim, xScale, brushRectIds, id, zaxisList, event) {
    
    d3v3.select('.foreground').selectAll("path").style("display", "none")
  
    
    var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
    if(logevents)
    {
            var eventlog = LogEvents.addEvent(id, PARALLEL_COORDINATES_CHART, PREDICTION, LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, null, null,null,null,zaxisList)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
    }
  
   
  }

  export function brushStart(dim){
    return d3v3.select("#"+dim.name+"parallelCoordinates").selectAll('rect')
  }